import { type TDomains, type BaseJsonConfiguration } from '@dhl/receiver-config'

export type MopinionSurveyConfiguration = {
  surveyId: number
  token: string
}

export const onboardingDomains = [
  'dhlecommerce.nl',
  'dhlecommerce.be',
  'dhlparcel.nl',
  'dhlparcel.be',
  'dhlexpress.nl',
] as const
export type OnboardingDomains = typeof onboardingDomains

export type OnboardingAppConfiguration = {
  apiGatewayHost: string
  basePath: string
  catchAllLink: string
  features: {
    c2c: {
      active: boolean
      activationPercentage: number
      askForPrintlessPhoto: {
        active: boolean
      }
      entrySummaryDeclaration: {
        active: boolean
      }
      reserveLocker: {
        active: boolean
      }
    }
    dashboard: {
      active: boolean
    }
    locator: {
      active: boolean
    }
    receive: {
      active: boolean
    }
    send: {
      active: boolean
    }
    more: {
      active: boolean
      goGreen: {
        active: boolean
      }
      deliveryPreferences: {
        active: boolean
      }
      joinDhl: {
        active: boolean
      }
    }
    profile: {
      active: boolean
    }
    app: {
      active: boolean
    }
    chat: {
      active: boolean
      chatbotUri: string
    }
    interventions: {
      active: boolean
      showServicepointLocatorMap: {
        active: boolean
      }
      useNeighbourInterventionStreetLookup: {
        active: boolean
      }
      useLockerNudge: {
        active: boolean
      }
      useNeighbourFeedback: {
        active: boolean
      }
    }
    maintenance: {
      active: boolean
    }
    trackTrace: {
      active: boolean
      receiverHost: string
    }
  }
  adobe: {
    url: string
  }
  datadog: {
    applicationId: string
    clientToken: string
    service: string
    logsSessionSampleRate: number
    rumSessionSampleRate: number
    rumSessionReplaySampleRate: number
  }
  gtm: {
    id: string
  }
  maps: {
    apiKey: string
  }
  mopinion: {
    token: string
  }
  mopinionSurveys: {
    surveyEndpoint: string
    c2cFeedback: MopinionSurveyConfiguration
    neighbourInterventionCompletedFeedback: MopinionSurveyConfiguration
    neighbourInterventionCommentFeedback: MopinionSurveyConfiguration
  }
  oneTrust: {
    id: string
  }
  prismic: {
    endpoint: string
  }
  util: {
    domainOverride?: string
  }
}

export type JsonConfiguration<
  TSupportedDomains extends TDomains,
  TAppConfiguration = OnboardingAppConfiguration,
> = BaseJsonConfiguration<TSupportedDomains, TAppConfiguration> & {
  BASE_PATH: string
}
